export default "__VITE_PUBLIC_ASSET__1c8f5122__"